// extracted by mini-css-extract-plugin
export default {"save_money_content":"index_save_money_content__JotEC","save_money":"index_save_money__aQrfc","add":"index_add__PKOc9"};